// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PoliciesAndNetworks_Wrapper__2_XYe","SocialNetworks":"PoliciesAndNetworks_SocialNetworks__1KsUN","Policies":"PoliciesAndNetworks_Policies__141ay"};